module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMBAMAAACQIoDIAAAAAXNSR0IArs4c6QAAAB5QTFRFAAAASFbxRlTuSFfuR1XuSFbuSFbvOl7sQFrtSFbu9AJ1/AAAAAd0Uk5TAEdJZ2zx/TtNSRcAAABFSURBVAjXY2AAAiYFBhgwS4axmDOnGcAEZ3QmwwTbK6DCZjPKyyHCQMHycogwSBAiDBaECKuBBYHCSQyiDhBzWAIZEAAAccEYYC+giTwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/filtrate_up.png
// module id = 1YoW
// module chunks = 0